export default __webpack_public_path__ + "static/icon-27-6-b2f0a7bd66f88e3a2d7ca1e389e6f236.png";